<table mat-table [dataSource]="dataSource">
    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef> {{column | translate}} </th>
        <td mat-cell *matCellDef="let element" [ngClass]="{'number-field':numberColumns.includes(column)}"> {{translateColumns.includes(column) ? (element[column] | translate) : element[column]}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
